import { Box } from "@mui/material";

import { ProjectHeader, ProjectClientInvoices } from "../../components/project";
import { PageLayout } from "../../layouts/PageLayout";

export const ProjectClientInvoice = () => {
  return (
    <PageLayout>
      <Box sx={{ position: "relative", zIndex: 1, marginTop: "22px" }}>
        <ProjectHeader title="Project GST Invoices" />
      </Box>
      <ProjectClientInvoices />
    </PageLayout>
  );
};
